import { LARGE_SCREEN_MEDIA_QUERY } from "shared/helpers/responsive_helpers"
import styled from "styled-components"
import { PRIMARY_COLOR_100, WHITE_COLOR } from "../styles"

export const Title1 = styled.h1`
  color: ${ PRIMARY_COLOR_100 };
  font-size: 2.25rem;
  font-weight: bold;
  text-transform: capitalize;

  @media ${ LARGE_SCREEN_MEDIA_QUERY } {
    font-size: 3.75rem;
  }
 `

export const Title2 = styled.h2`
  font-size: 2rem;
  font-weight: bold;
  text-transform: capitalize;
`

// tslint:disable-next-line: space-within-parens
export const Title2LG = styled(Title2)`
  font-size: 2.25rem;
`

export const Title3 = styled.h3`
  color: ${ WHITE_COLOR };
  font-size: 1.25rem;
  text-transform: uppercase;
`

interface Title3VariableFont {
  textSize: string
}

export const Title3VariableTextSize = styled.h3<Title3VariableFont>`
  font-size: ${ ( props ) => props.textSize }
`
